import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../app-common/shared.module';
import {BookTimeNowService} from './services/book-time-now.service';
import {BookTimeNowWidgetComponent} from './components/book-time-now-widget/book-time-now-widget.component';
import {UiButtonComponent} from '../ui/ui-button/ui-button.component';
import {UiIconComponent} from '../ui/ui-icon/ui-icon.component';

@NgModule({
  providers: [BookTimeNowService],
  imports: [RouterModule, SharedModule, UiButtonComponent, UiIconComponent],
  declarations: [BookTimeNowWidgetComponent],
  exports: [BookTimeNowWidgetComponent],
})
export class BookTimeNowModule {}
